export default __webpack_public_path__ + "static/media/frg--castle-hill.46ca9165.png";